// extracted by mini-css-extract-plugin
export default {"content":"About_content__7pSBP","intro":"About_intro__NIwS5","emphasis":"About_emphasis__E1QtJ"};